import { createMainBrowserBranding } from "./main.ts";
import { BrowserBranding } from "./types.ts";
import { createWhiteLabelBrowserBranding } from "./white-label.ts";

function getBrowserBrandingById(id: string): BrowserBranding {
	switch (id) {
		case "white-label":
			return createWhiteLabelBrowserBranding();
		case "main":
			return createMainBrowserBranding();
		default:
			throw new Error(`Unknown branding id ${id}`);
	}
}

export { getBrowserBrandingById };
